import * as React from 'react';
import { useSelector } from 'react-redux';
import { ElementInViewport } from '../../components/element_in_viewport';

import { OneTwoTripBanner } from '../../components/OneTwoTripBanner';
import { selectOneTwoTripBannerExperimentEnabled } from '../../selectors/experiments/selectOneTwoTripBannerExperimentEnabled';
import { trackBannerClick, trackBannerShow } from './tracking';

const ONE_TWO_TRIP_URL =
  'https://cian.onetwotrip.com/?activePage=hotel&isStart=false&636bd81ac76114bf06b41e60=&utm_source=cian&utm_medium=partner&utm_campaign=home_page_block';

export const OneTwoTripBannerContainer: React.VFC = () => {
  const isBannerActive = useSelector(selectOneTwoTripBannerExperimentEnabled);

  if (!isBannerActive) {
    return null;
  }

  const onClick = () => trackBannerClick();

  return (
    <ElementInViewport
      onChange={isVisible => {
        if (isVisible) {
          trackBannerShow();
        }
      }}
    >
      <OneTwoTripBanner onClick={onClick} url={ONE_TWO_TRIP_URL} />
    </ElementInViewport>
  );
};
